import { Injectable } from '@angular/core';

import type { PaymentInterval } from '@core/billing-types';
import { Currency, PricingCompanySizeE } from '@core/billing-types';
import { LocalStorageService } from '@core/common-legacy';

type PersistenceData = {
  companySize: string;
  interval: PaymentInterval;
  currency: Currency;
};

@Injectable()
export class ProductOrderPersistenceService {
  private readonly key = 'product-order-persistence';
  constructor(private localStorage: LocalStorageService) {}

  public save(data: PersistenceData) {
    this.localStorage.set(this.key, data);
  }

  public read(): PersistenceData | undefined {
    const value = this.localStorage.get(this.key, undefined);
    if (!value) return undefined;
    const companySize = value['companySize'] || PricingCompanySizeE['1-20'];
    const interval = value['interval'] ? this.parseInterval(value['interval']) : 12;
    const currency =
      value['currency'] && Object.values(Currency).includes(value['currency'])
        ? value['currency']
        : Currency.EUR;
    return {
      companySize,
      interval,
      currency,
    };
  }

  public clear() {
    this.localStorage.remove(this.key);
  }

  private parseInterval(val: any): PaymentInterval {
    const parsed = parseInt(val, 10);
    return parsed === 1 || parsed === 12 ? parsed : 12;
  }
}
